export enum modes {
    tracker = 'tracker',
    periodic = 'periodic',
    alarm = 'alarm',
}
